// Values are the card title rendered to the investor, and must stay byte-identical to the backend
// enum and the activity_feed_eventname_enum Postgres type.
export enum ActivityFeedEventName {
  PROPERTY_ADDED = 'Property added',
  PROPERTY_LISTED = 'Property listed',
  PROPERTY_RENTED_OUT = 'Property rented out',
  APPLICATION_SENT = 'Application sent',
  APPLICATION_REQUESTED = 'Application requested',
  APPLICATION_STARTED = 'Application started',
  CO_APPLICANT_INVITED = 'Co-applicant invited',
  CO_SIGNER_INVITED = 'Co-signer invited',
  APPLICANT_REMOVED = 'Applicant removed',
  SCREENING_FEE_PAID = 'Screening fee paid',
  BACKGROUND_CHECK_COMPLETED = 'Background check completed',
  APPLICATION_READY_TO_SUBMIT = 'Ready to submit',
  APPLICATION_COMPLETED = 'Application completed',
  APPLICATION_APPROVED = 'Application approved',
  APPLICATION_DECLINED = 'Application declined',
  APPLICATION_UPDATE_REQUESTED = 'Application update requested',
  APPLICATION_RESUBMITTED = 'Application resubmitted',
  SHOWING_REQUESTED = 'Showing requested',
  SHOWING_CONFIRMED = 'Showing confirmed',
  SHOWING_COMPLETED = 'Showing completed',
  SHOWING_ATTENDANCE_CONFIRMED = 'Attendance confirmed',
  SHOWING_ATTENDANCE_DECLINED = 'Attendance declined',
  NEW_LEAD = 'New lead',
  LEAD_QUALIFIED = 'Lead qualified',
}
